import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  componentDidMount(){
    this.updateHeight();
    window.onresize = () => this.updateHeight();
  }

  updateHeight(){
    const height = this.divElement.clientHeight;
    this.props.updateHeight(height);
  }

  render() {
    return (
      <div className="header"
            ref={ (divElement) => this.divElement = divElement  }>
        <h1 className="title">Tanner Graham</h1>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header/Header.js